import RequestBuilder from "../RequestBuilder"
import {Method} from "../enum/Method"
import {ModelPlatform} from "../enum/ModelPlatform"
import {ScoringMethod} from "../enum/ScoringMethod"
import QualityCheckJson from "../json/QualityCheckJson"
import {PagedResponseJson} from "../json/PagedResponseJson"

interface CreateTransformQualityCheckBody {
    expectedOutputColumnId: string
    completionPlatform: ModelPlatform
    completionModelName: string
    scoringMethod?: ScoringMethod
    temperature?: number
    topP?: number | null
    presencePenalty?: number | null
    frequencyPenalty?: number | null
    maxTokens?: number | null
}

export class TransformQualityCheckRequests {
    static create(projectId: string, transformId: string, body: CreateTransformQualityCheckBody): Promise<QualityCheckJson> {
        return new RequestBuilder(Method.Post, `projects/${projectId}/transforms/${transformId}/quality-checks`)
            .withJson(body)
            .buildAndSend()
    }

    static list(projectId: string, transformId: string, page: number = 0): Promise<PagedResponseJson<QualityCheckJson>> {
        return new RequestBuilder(Method.Get, `projects/${projectId}/transforms/${transformId}/quality-checks?page=${page}`)
            .buildAndSend()
    }

    static delete(projectId: string, transformId: string, qualityCheckId: string): Promise<void> {
        return new RequestBuilder(Method.Delete, `projects/${projectId}/transforms/${transformId}/quality-checks/${qualityCheckId}`)
            .buildAndSend()
    }
}
